import { render, staticRenderFns } from "./ThreeTable2.vue?vue&type=template&id=61495d9c&scoped=true&slot-scope=scope&"
import script from "./ThreeTable2.vue?vue&type=script&lang=js&"
export * from "./ThreeTable2.vue?vue&type=script&lang=js&"
import style0 from "./ThreeTable2.vue?vue&type=style&index=0&id=61495d9c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61495d9c",
  null
  
)

export default component.exports